// extracted by mini-css-extract-plugin
module.exports = {"item":"goodPoints_item__99k-5","itemText":"goodPoints_itemText__A1omx","icon":"goodPoints_icon__3znzQ"};